<template>
	<div class="customMobile-layout-cls loginLoader h-100">
		<loader v-if="pageLoader"></loader>
		<div class="row h-100">
			<div class="col-12 col-md-7 d-flex flex-column justify-content-center">
				<div class="capitalLoginForm">
					<div class="lt-aler-message" v-if="notification_msg != ''">
						<alert-notification/>
					</div>
					<div class="capitalLoginFormMid">
						<img src="../../../../static/website/images/logo.svg" alt="Logo" class="loginLogo mb-2">
						<h2 class="my-md-4">Forgot Password</h2>
						<form class="mt-4" v-on:submit.stop.prevent="submit()" >
							<div class="form-group" v-if="!resend">
								<label class="labeltext">Email</label>
								<div class="position-relative">
									<input type="text" placeholder=" " class="form-control" v-model="email" name="email" v-validate="'required|email'">
									<span class="text-danger" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</span>
									<span class="ico"><feather type="user"></feather></span>
								</div>
							</div>

							<div v-else class="resendMail text-center">
								<img class="mb-3" src="../../../../static/website/images/emailSend.png" alt="icon">
								<p>We have sent a password reset link to your email. Please check your mailbox and spam folder. If it does not arrive soon, click on the ""Resend Email"" button below. Need help? <a href="https://capitalwallet.com/contact-us" >Contact Support</a></p>
							</div>

							<div class="form-group d-flex align-items-center justify-content-between mt-4 mt-md-5">
								<input type="submit" class="cap_btn blue large_btn" :class="(pageLoader)?'disabled':''" :value="(!resend)?'Reset Password':'Resend Email'" name="submitFrm">
								<router-link :to="'/'" class="donthaceaccount router-link-active">Back To Login ?</router-link>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-5 hide-767 d-flex flex-column justify-content-center themeBG">
				<div class="imageForgot">
					<img class="mx-auto d-block" width="400" src="../../../../static/website/images/3432678.svg" :alt="$env_var.productName">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as types from '@/types'
	import { mapActions } from 'vuex'
	export default {
		name: 'App-Login',
		data() {
			return {
				pageLoader: false,
				submitted: false,
				notification_msg:'',
                notification_type:'',
				email: '',
				resend : false
			}
		},
		methods: {
			...mapActions({
                _runForgotPassword: types.RUN_FORGOT_PASSWORD
            }),
            submit(){
            	if(this.pageLoader){return;}
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                "email": _that.email
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runForgotPassword(input_json)
                    }
                });
            }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/website/user/forgot_password.vue